import {
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    GroupeBouton,
    Bouton,
} from '@design-system-etat/dsfr-react';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './ModalePerteVol.module.scss';

const ModalePerteVol = ({ fermerModale, etape2PerteVol }) => {
    const { REACT_APP_CONTACT_GENDARMERIE_POLICE_URL } = process.env;

    return (
        <>
            <Modale taille="lg" closeCallback={fermerModale}>
                <ModaleTitre>Signaler la perte ou le vol d'une arme :</ModaleTitre>
                <ModaleContent>
                    <p className={styles.modalePerteVol__description}>
                        Si vous avez perdu ou que vous vous êtes fait voler une arme ou un élément
                        d&apos;arme des catégories A, B, ou C vous devez immédiatement faire une
                        déclaration au commissariat de police ou à la brigade de gendarmerie.
                    </p>
                    <p className={styles.modalePerteVol__texteGras}>Où s&apos;adresser ?</p>
                    <a
                        title="Ministère de l'intérieur - Contact Gendarmerie Police"
                        href={REACT_APP_CONTACT_GENDARMERIE_POLICE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Contacter une brigade de gendarmerie ou un commissariat de police
                    </a>
                    <p className={styles.modalePerteVol__avertissement}>
                        Pour signaler la perte ou le vol d&apos;une arme sur votre espace
                        détenteurs, vous devez importer le récépissé de déclaration de perte ou de
                        été remis par les services de police ou de gendarmerie
                    </p>
                </ModaleContent>
                <ModaleFooter>
                    <GroupeBouton alignementHorizontal="right" isHorizontal>
                        <Bouton label="Annuler" onClick={fermerModale} />
                        <Bouton
                            name="Continuer"
                            label="Continuer"
                            niveau="primaire"
                            onClick={etape2PerteVol}
                        />
                    </GroupeBouton>
                </ModaleFooter>
            </Modale>
        </>
    );
};

ModalePerteVol.propTypes = {
    fermerModale: PropTypes.func.isRequired,
    etape2PerteVol: PropTypes.func.isRequired,
};

export default ModalePerteVol;
